import React from 'react';
import Link from '@mui/material/Link';
import useSignedFileUrl from '../helpers/authenticatedFile';

// A link to a stored document that the browser can follow on its own.
//
// The route requires a token, and a plain <a href> is followed without an
// Authorization header, so a link to a guarded upload used to land on a 401.
// Signing the path puts the credential in the URL instead, which makes this an
// ordinary link again - cached, and openable in a new tab like any other.
//
// Remote URLs are returned untouched, since they were never served by us.
const AuthenticatedFileLink = ({path, children}) => {
    const { url } = useSignedFileUrl(path);

    if (!path) return null;

    const label = children || String(path).split(/[\\/]/).pop();

    if (!url) return null;

    return (
        <Link target="_blank" rel="noopener noreferrer" href={url}>
            {label}
        </Link>
    );
};

export default AuthenticatedFileLink;